/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReferralsSection/view.blocks to change it.
import Add from './Add/index'
import React from 'react'
import Referrals from './Referrals/index'



/** @type {import('Simple/types.js').View} */
export default function ReferralsSection({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection"
  
}) {
  return (<React.Fragment
>
<Referrals
  viewPath={`${viewPath}/Referrals`}
/>
<Add
  viewPath={`${viewPath}/Add`}
/>
{children}
</React.Fragment>)
}